module.exports = __webpack_public_path__ + "img/2688118-55-8.8a9de0d7.png";